module.exports = __webpack_public_path__ + "img/gitefrance.0f2e6ae5.png";